var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPen(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.9712 7.6329L19.4712 5.12082C20.1442 4.44449 20.1442 3.38169 19.4712 2.70536L17.3077 0.483137C16.6346 -0.193191 15.5769 -0.193191 14.9039 0.483137L12.4039 2.99521C11.7308 3.67154 11.7308 4.73435 12.4039 5.41067L14.6154 7.6329C15.2885 8.30923 16.3462 8.30923 16.9712 7.6329Z",
    fill: "#544D56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.2538e-06 18.1643L0.0480792 16.0386C0.0480792 15.6039 0.240387 15.2174 0.528848 14.8792L9.08654 6.2802C9.75962 5.60387 10.8173 5.60387 11.4904 6.2802L13.7019 8.50242C14.375 9.17875 14.375 10.2415 13.7019 10.9179L5.19231 19.5169C4.85577 19.8551 4.42308 20.0483 3.94231 20L1.63462 19.9034C0.721156 19.9034 -0.0480747 19.1304 2.2538e-06 18.1643Z",
    fill: "#544D56"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPen);
export default __webpack_public_path__ + "static/media/pen.53120677.svg";
export { ForwardRef as ReactComponent };